<template>
    <app-main :classes="{'login': true}">
        <div class="block relative">
            <div class="absolute pin bg-white z-20" v-if="loading">
                <div class="absolute" style="top: 50%; left: 50%; transform: translate(-50%, -50%);">
                    <app-loader />
                </div>
            </div>

            <div class="block" v-if="!forgotten">
                <app-auth-login @loading="set" />
            </div>
        </div>
    </app-main>
</template>

<script>
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Loader from '@/components/Loader';
    
    import AuthLogin from '@/components/auth/Login';
    import AuthForgot from '@/components/auth/Forgot';
    
    export default {
        name: 'login',
        data: () => ({
            forgotten: false,
            loading: false
        }),
        components: {
            'app-main': Main,
            'app-loader': Loader,
            'app-auth-login': AuthLogin,
            'app-auth-forgot': AuthForgot
        },
        methods: {
            toggle() {
                event.preventDefault();
                if(!this.loading) {
                    this.forgotten = !this.forgotten;
                }
            },
            set(loading) {
                this.loading = loading;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/Login.vue